import config from '@/core/config/config';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { ChevronRight } from '@prenuvo/halo-icon';
import { Button, Typography } from '@prenuvo/halo-web';
import { useShallow } from 'zustand/react/shallow';

export const ConfirmationFooter = () => {
  const { userId, transactionId } = usePrenuvoStore(
    useShallow((state) => ({
      userId: state.user.userId,
      transactionId: state.payment.transactionId,
    })),
  );

  const handleRedirect = () => {
    window.open(`${config.BASE_URL}/user/dashboard`, '_self');
  };

  return (
    <>
      {userId ? (
        <Button
          rightIcon={ChevronRight}
          size="lg"
          variant="gradient"
          onClick={handleRedirect}
          className={{
            root: 'w-full md:w-auto',
          }}
        >
          <span className="md:pr-16">Continue</span>
        </Button>
      ) : (
        <Typography
          variant="paragraph-md"
          as="p"
          className="pb-4 text-sm leading-6 text-teal-500 sm:pb-0"
        >
          Check your email to complete setting up your Prenuvo account
        </Typography>
      )}
    </>
  );
};
